import React, { useLayoutEffect } from 'react'
import { useLoaderData } from 'react-router'
import PageNavContainer from '../../../state/PageNavContainer'
import FeedbackVideoTestimonialPage from './FeedbackVideoTestimonialPage'

// -----------------------------------------------------------------------------
// Const
// -----------------------------------------------------------------------------

const PAGE_ID = `feedback-video-testimonial`

// -----------------------------------------------------------------------------
// Component
// -----------------------------------------------------------------------------

const FeedbackVideoTestimonialModule = () => {
  const loaderData = useLoaderData()
  const [, setNav] = PageNavContainer.useContainer()

  useLayoutEffect(() => {
    setNav({
      pageId: PAGE_ID,
    })
  }, [setNav])

  return <FeedbackVideoTestimonialPage content={loaderData.page.content} />
}

export default FeedbackVideoTestimonialModule
